import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { getGender } from 'lvovich';

import Register from './Register';
import { unauthHeaders } from '../../utils/API';
import moment from 'moment';
import { emailValidator, phoneValidator, snilsValidation } from '../../utils/validators';

const RegisterContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);

    const [lastName, setLastName] = useState();
    const [firstName, setFirstName] = useState();
    const [middleName, setMiddleName] = useState();
    const [phone, setPhone] = useState();
    const [dateBirthday, setDateBirthday] = useState(null);
    const [snils, setSnils] = useState();
    const [sex, setSex] = useState(0);
    const [email, setEmail] = useState();

    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [successMessage, setSuccessMessage] = useState();

    const registerNewUser = () => {
        sessionStorage.setItem('forgot_userName', parseInt(phone?.replace(/\D+/g, "")));
        setIsLoading(true);
        axios.post(`${process.env.REACT_APP_API}api/v1.0/auth/CreateUserProfileAndMedicalCard`, {
            PersonFIO: {
                FirstName: firstName?.trim(),
                MiddleName: middleName?.trim(),
                LastName: lastName?.trim()
            },
            PhoneNumber: parseInt(phone?.replace(/\D+/g, "")),
            Birthday: moment(dateBirthday).format('YYYY-MM-DD'),
            Sex: sex,
            Snils: snils?.trim(),
            Email: email?.trim(),
        }, {
            headers: unauthHeaders
        })
            .then((res) => {
                setIsLoading(false);
                setSuccessMessage(res.data.integrationResponse.errorText);
                setTimeout(() => {
                    history.push(`${process.env.REACT_APP_WEBSITE_NAME}/`);
                }, 3000);
            })
            .catch((err) => {
                console.log(err);
                if (err.response.data?.forceException) {
                    setErrorMessage(err.response.data?.message);
                    console.log('Error: ', err.response.data?.message);
                    setIsLoading(false);
                    return;
                }
                setErrorMessage('Пациент с указанными данными не найден, проверьте информацию');
                console.log('Error: ', err.response.data?.message);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        const sexText = getGender({ last: lastName, first: firstName, middle: middleName });
        switch (true) {
            case sexText && sexText.includes('female'):
                setSex(1);
                break;
            case sexText && sexText.includes('male'):
                setSex(2);
                break;
            default:
                setSex(0);
        }
    }, [lastName, firstName, middleName]);

    const onHandleRegister = () => {
        setIsError(false);
        setErrorMessage("");

        if (!lastName || !firstName || !sex || !phone || !dateBirthday || !snils) {
            setIsError(true);
            setErrorMessage("Заполните все обязательные поля");
            return;
        }

        let customErr = { code: '', message: '' };
        if (!phoneValidator(phone, customErr)) {
            setIsError('phone');
            setErrorMessage(customErr.message);
            return;
        }
        if (!snilsValidation(snils, customErr)) {
            setIsError('snils');
            setErrorMessage(customErr.message);
            return;
        }
        if (email && !emailValidator(email, customErr)) {
            setIsError('email');
            setErrorMessage(customErr.message);
            return;
        }

        registerNewUser();
    }

    const onChangeSex = (e) => {
        setSex(e);
    }

    const onChangePhone = (e) => {
      setPhone(e);
      sessionStorage.setItem('forgot_userName', e);
    }

    return (
        <>
            <Register
                isLoading={isLoading}
                lastName={lastName}
                setLastName={setLastName}
                firstName={firstName}
                setFirstName={setFirstName}
                middleName={middleName}
                setMiddleName={setMiddleName}
                phone={phone}
                setPhone={onChangePhone}
                dateBirthday={dateBirthday}
                setDateBirthday={setDateBirthday}
                snils={snils}
                setSnils={setSnils}
                email={email}
                setEmail={setEmail}
                isError={isError}
                onHandleRegister={onHandleRegister}
                successMessage={successMessage}
                errorMessage={errorMessage}
                sex={sex}
                onChangeSex={onChangeSex}
            />
        </>
    )
}

export default RegisterContainer;
